import { render, staticRenderFns } from "./user_profile_current.vue?vue&type=template&id=b8b80860&scoped=true"
import script from "./user_profile_current.vue?vue&type=script&lang=js"
export * from "./user_profile_current.vue?vue&type=script&lang=js"
import style0 from "./user_profile_current.vue?vue&type=style&index=0&id=b8b80860&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8b80860",
  null
  
)

export default component.exports